import { useRouter } from 'vue-router';
import {
  CALENDAR_EVENT_NAVIGATION_MODES,
  calendarEventNavigation,
} from '@/js/core/utils/calendar-events.js';

export const calendarEventNavigationModeProp = {
  type: String,
  default: CALENDAR_EVENT_NAVIGATION_MODES.modal,
  validator: value => Object.values(CALENDAR_EVENT_NAVIGATION_MODES).includes(value),
};

export function useCalendarEventNavigation(props) {
  const router = useRouter();
  const eventNavigation = event =>
    calendarEventNavigation(event, {
      mode: props.eventNavigationMode,
      timezone: props.timezone,
    });

  // Both modes navigate through the router; they differ only in the href being pushed.
  // Link mode belongs to the block islands, which sit on arbitrary content pages, so its
  // href carries the return path telling the modal which page to restore on close.
  const navigate = (domEvent, event) => {
    const navigation = eventNavigation(event);
    if (!navigation.isInteractive) return;

    domEvent.preventDefault();
    router.push(navigation.href);
  };

  const handleEventClick = (domEvent, event) => {
    // Let Cmd/Ctrl/Shift/Alt-click open in a new tab/window natively.
    if (domEvent.metaKey || domEvent.ctrlKey || domEvent.shiftKey || domEvent.altKey) return;

    navigate(domEvent, event);
  };

  const handleEventKeydown = (keyboardEvent, event) => {
    if (keyboardEvent.key !== 'Enter' && keyboardEvent.key !== ' ') return;

    navigate(keyboardEvent, event);
  };

  return {
    eventNavigation,
    handleEventClick,
    handleEventKeydown,
  };
}
